'use client';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { TournamentList } from '@/components/tournament/TournamentList';
import { FieldHelp, useAutoStartTour } from '@/features/guided-help';
import { useTournamentStore } from '@/store/useTournamentStore';
import { MercadoPagoAuthModal } from '@/components/mercadopago/MercadoPagoAuthModal';
import { useMercadoPagoAuth } from '@/hooks/useMercadoPagoAuth';

export default function HomePage() {
  const {
    isModalOpen,
    setIsModalOpen,
    handleNavigateNewTournament,
    handleAuthorizeMercadoPago,
  } = useMercadoPagoAuth();
  const navigate = useNavigate();
  const { tournaments, isLoading, error, refreshTournaments } =
    useTournamentStore();

  useAutoStartTour('panel.tournaments');

  useEffect(() => {
    // Refresh the list every time the page is entered to see updated data
    refreshTournaments();
  }, [refreshTournaments]);

  const handleTournamentClick = (tournamentId: string) => {
    navigate(`/torneos/${tournamentId}`);
  };

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <section>
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-2">
            <h1 className="text-3xl font-bold text-gray-900">
              Administración de Torneos
            </h1>
            <FieldHelp topicId="panel.tournaments.list" />
          </div>
          <Button
            onClick={handleNavigateNewTournament}
            data-guide-id="panel.tournaments.create"
            className="flex w-full items-center justify-center gap-2 sm:w-auto"
          >
            <Plus size={18} />
            <span>Crear Nuevo Torneo</span>
          </Button>
        </div>

        <div data-guide-id="panel.tournaments.list">
          <TournamentList
            tournaments={tournaments}
            isLoading={isLoading}
            error={error}
            onTournamentClick={handleTournamentClick}
          />
        </div>
      </section>

      <MercadoPagoAuthModal
        isOpen={isModalOpen}
        onOpenChange={setIsModalOpen}
        onAuthorizeMercadoPago={handleAuthorizeMercadoPago}
      />
    </div>
  );
}
